import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, icon, MediaBreakPointUp, utils } from '@lean-body/components/styles';
export const Equip = (props) => {
    const containerClass = [props.className || '', css(styles.container)].join(' ');
    const e = props.equip;
    const iconClass = css(icon.anticon, icon.anticonExternalLink, styles.icon);
    return (React.createElement("div", { className: containerClass },
        React.createElement("a", { href: e.linkTo, className: css(styles.imgContainer), target: "_blank" },
            React.createElement("img", { src: e.thumbnailURL, className: css(utils.imgFluid) })),
        React.createElement("div", { className: css(styles.name) },
            e.name,
            " ",
            React.createElement("i", { className: iconClass }))));
};
const borderRadiusSize = 4;
const imgSize = {
    xs: 80,
    lg: 100,
};
const styles = StyleSheet.create({
    container: {
        width: imgSize.xs,
        [MediaBreakPointUp.LG]: {
            width: imgSize.lg,
        },
    },
    icon: {
        fontSize: '.875rem',
        verticalAlign: 'bottom',
    },
    imgContainer: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors.White,
        border: `1px solid ${Colors.Gray}`,
        borderRadius: borderRadiusSize,
        overflow: 'hidden',
        marginBottom: '.5rem',
        width: imgSize.xs,
        height: imgSize.xs,
        [MediaBreakPointUp.LG]: {
            width: imgSize.lg,
            height: imgSize.lg,
        },
        ':before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            zIndex: 1,
            backgroundColor: Colors.Black,
            opacity: 0,
            transition: 'opacity .6s ease',
            borderRadius: borderRadiusSize,
            width: imgSize.xs,
            height: imgSize.xs,
            [MediaBreakPointUp.LG]: {
                width: imgSize.lg,
                height: imgSize.lg,
            },
        },
        ':hover:before': {
            opacity: 0.7,
        },
        ':after': {
            content: '"詳細"',
            display: 'inline-block',
            position: 'absolute',
            zIndex: 2,
            top: 0,
            bottom: 0,
            margin: 'auto',
            color: Colors.White,
            opacity: 0,
            transition: 'opacity .6s ease',
            fontSize: '.875rem',
            height: '1em',
            lineHeight: 1,
        },
        ':hover:after': {
            opacity: 1,
        },
    },
    name: {
        color: Colors.GrayDarkest,
        lineHeight: 1.2,
        textAlign: 'center',
        fontSize: '10px',
        [MediaBreakPointUp.LG]: {
            fontSize: '12px',
        },
    },
});
